( function () {
    'use strict';
    ( function ( $ ) {
        $(".button-upload").click(function(e) {
            e.preventDefault();
            $(this).next().find('.upload-button').click();
        });
        $('.upload-button').change(function() {
            if($(this).val()!=""){
                $(this).parents('.em-field-upload').find('.file-limit-text').text($(this).val());
            }
            else{
                $(this).parents('.em-field-upload').find('.file-limit-text').text($(this).parents('.em-field-upload').find('.file-limit-text').data('text'));
            }
        });

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            $('.file-limit-text').text($('.file-limit-text').data('text'));
        }, false );

    } )( jQuery );
} )();